import { Users, CalendarDays, Sparkles, PhoneCall, CheckCircle2 } from "lucide-react";

const cards = [
  { key: "total", label: "Total de leads", icon: Users, tone: "bg-navy text-white" },
  { key: "hoy", label: "Hoy", icon: CalendarDays, tone: "bg-brand-blue text-white" },
  { key: "nuevos", label: "Nuevos", icon: Sparkles, tone: "bg-amber-500 text-white" },
  { key: "contactados", label: "Contactados", icon: PhoneCall, tone: "bg-sky-500 text-white" },
  { key: "cerrados", label: "Cerrados", icon: CheckCircle2, tone: "bg-growth text-white" },
];

export const StatsCards = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-testid="admin-stats">
    {cards.map(({ key, label, icon: Icon, tone }) => (
      <div key={key} className="rounded-2xl bg-white border border-slate-200 p-5 card-lift" data-testid={`admin-stat-${key}`}>
        <span className={`grid place-items-center h-10 w-10 rounded-xl ${tone}`}>
          <Icon className="h-5 w-5" />
        </span>
        <p className="mt-4 font-heading text-3xl font-extrabold text-navy" data-testid={`admin-stat-${key}-value`}>
          {stats ? stats[key] : "—"}
        </p>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</p>
      </div>
    ))}
  </div>
);
